// extracted by mini-css-extract-plugin
export default {"Container":"BranchDescription-module__Container--i81bZ","ActionGroup":"BranchDescription-module__ActionGroup--yPboU"};